export default {
  strict: true,
  namespaced: true,
  state: {
    list: [],
    serviceLoading: false
  },
  mutations: {
    clearService (state) { state.list = [] },
    addService (state, value) { state.list.push(value) },
    removeNewService (state) {
      let index = state.list.findIndex(x => x.id === 0)
      if (index > -1) {
        state.list.splice(index, 1)
      }
    },
    setServiceEnable (state, data) {
      let index = state.list.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.list[index].enabled = data.enabled
      }
    },
    setServiceId (state, value) {
      let index = state.list.findIndex(x => x.id === 0)
      if (index > -1) {
        state.list[index].id = value
      }
    },
    setServiceLoading (state, value) { state.serviceLoading = value }
  },
  sharedMutations: []
}


// WEBPACK FOOTER //
// ./src/store/services/list.js